import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/mockup-1.png'
import _imports_1 from '@/assets/icon.svg'


const _hoisted_1 = {
  class: "mockup xyz-in",
  xyz: "fade"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Locate any phone, anywhere",
  class: "xyz-in",
  xyz: "left fade duration-6 delay-3",
  style: {"--xyz-translate-x":"30%"}
}, null, -1)
const _hoisted_3 = {
  class: "alert xyz-nested",
  xyz: "fade down small-5 delay-9 duration-4 ease-out-back"
}
const _hoisted_4 = { class: "text-primary mb-05" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Finda"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "divider mb-05" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h6", _hoisted_4, [
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString($setup.strings.home.main[18]), 1)
      ]),
      _hoisted_6,
      _createElementVNode("p", null, _toDisplayString($setup.strings.home.main[20]), 1)
    ])
  ]))
}